import ServiceGraphQL from 'src/service/gql-service';
import { createMicrosite } from 'src/graphql';

const serviceGraphQL = new ServiceGraphQL();

/** Action creators */
export const CreateMicrosite = (data) => {
  const params = {
    query: createMicrosite.QUERY,
    variables: {}
  };
  return serviceGraphQL
    .post(params)
    .then((res) => {
      return res.data.createMicrosite;
    })
    .catch((err) => {
      throw err;
    });
};
